import Eula from "../../../components/Terms/Eula";

const EulaPage = () => {
    return (
        <Eula></Eula>
    );
}

export default EulaPage;
